export const routes = (prefix=`registration`) => [
    {
        path: `/${prefix}/current-visits`,
        name: `${prefix}.current-visits.create`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.current-visits.create`,
                PageDescription: "Patient Management - View current visits",
            },
        },
    },
];
